import { render, staticRenderFns } from "./tab_detail.vue?vue&type=template&id=3088981e&scoped=true&"
import script from "./tab_detail.vue?vue&type=script&lang=js&"
export * from "./tab_detail.vue?vue&type=script&lang=js&"
import style0 from "./tab_detail.vue?vue&type=style&index=0&id=3088981e&lang=scss&scoped=true&"
import style1 from "./tab_detail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3088981e",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabItem } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';
import { VTabsItems } from 'vuetify/lib/components/VTabs';
import { VTabsSlider } from 'vuetify/lib/components/VTabs';
installComponents(component, {VCard,VTab,VTabItem,VTabs,VTabsItems,VTabsSlider})


/* hot reload */
if (module.hot) {
  var api = require("/home/eu/public_ru/local/templates/international/int_site/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3088981e')) {
      api.createRecord('3088981e', component.options)
    } else {
      api.reload('3088981e', component.options)
    }
    module.hot.accept("./tab_detail.vue?vue&type=template&id=3088981e&scoped=true&", function () {
      api.rerender('3088981e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/main/tab_detail.vue"
export default component.exports